import { render, staticRenderFns } from "./ViewSingleQuoteLegacy.vue?vue&type=template&id=8d975958"
import script from "./ViewSingleQuoteLegacy.vue?vue&type=script&lang=ts"
export * from "./ViewSingleQuoteLegacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports